var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnalyze({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "027-share") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homepage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-560.000000, -1215.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "How-it-works",
    transform: "translate(0.000000, 980.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groups",
    transform: "translate(186.000000, 217.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Analyze",
    transform: "translate(365.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "027-share",
    transform: "translate(8.125392, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2063714,12.550427 C12.4723011,12.550427 11.8046107,12.8337863 11.3087437,13.2946143 L7.79529011,10.6249899 C7.9301208,10.2559196 8.00378492,9.85840802 8.00378492,9.44419717 C8.00378492,9.02998632 7.9301208,8.63247469 7.79529011,8.26340446 L11.4580715,5.48033084 C12.0339586,6.01189323 12.8077353,6.33796737 13.6575329,6.33796737 C15.4322919,6.33796737 16.8761872,4.91638956 16.8761872,3.16898369 C16.8761872,1.42161297 15.4322919,0 13.6575329,0 C11.8827739,0 10.4388786,1.42161297 10.4388786,3.16898369 C10.4388786,3.70033513 10.5726024,4.20145221 10.8083419,4.64174899 L7.27607054,7.325682 C6.62637657,6.48783844 5.60179186,5.94615105 4.4509462,5.94615105 C2.49190196,5.94615105 0.898107484,7.51534993 0.898107484,9.44416201 C0.898107484,11.3729741 2.49190196,12.9422081 4.4509462,12.9422081 C5.60179186,12.9422081 6.62637657,12.4005207 7.27607054,11.5626772 L10.6854017,14.1532001 C10.5275398,14.495657 10.4388786,14.8753093 10.4388786,15.2751764 C10.4388786,16.7776135 11.6803851,17.9999609 13.2063714,17.9999609 C14.7323578,17.9999609 15.9738642,16.7776135 15.9738642,15.2751764 C15.9738642,13.7727392 14.7323935,12.550427 13.2063714,12.550427 Z M13.6575329,1.05468727 C14.841622,1.05468727 15.8049688,2.00316753 15.8049688,3.16898369 C15.8049688,4.33479984 14.8416577,5.2832801 13.6575329,5.2832801 C12.4734438,5.2832801 11.5100971,4.33479984 11.5100971,3.16898369 C11.5100971,2.00316753 12.4734438,1.05468727 13.6575329,1.05468727 Z M4.4509462,11.8875209 C3.08257179,11.8875209 1.9693259,10.7914547 1.9693259,9.44416201 C1.9693259,8.09690449 3.08257179,7.00083832 4.4509462,7.00083832 C5.81932061,7.00083832 6.9325665,8.09690449 6.9325665,9.44416201 C6.9325665,10.7914547 5.81935632,11.8875209 4.4509462,11.8875209 Z M13.2063714,16.9453088 C12.2710549,16.9453088 11.5100971,16.1961293 11.5100971,15.2752115 C11.5100971,14.3543289 12.2710549,13.6051142 13.2063714,13.6051142 C14.1416879,13.6051142 14.9026458,14.3543289 14.9026458,15.2752115 C14.9026458,16.1961293 14.1417236,16.9453088 13.2063714,16.9453088 Z",
    id: "Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalyze);
export default __webpack_public_path__ + "static/media/icon-analyze.24600f18a1227cab3455d823048b99cb.svg";
export { ForwardRef as ReactComponent };